<div class="wrap" #content>
  <ng-container>
    @switch (strategy) {
      @case ('replace') {
        @if (showLoading) {
          @if (type === 'linear') {
            <div class="linear-wrapper" [ngClass]="{'fixed-loader': isFixed}">
              <mat-progress-bar mode="indeterminate" [ngStyle]="{'height.px': linearHeight}"></mat-progress-bar>
            </div>
          }
          @if (type === 'circular') {
            <div class="spinner-wrapper">
              <mat-spinner [diameter]="circularHeight"></mat-spinner>
            </div>
          }
        } @else {
          <ng-container *ngTemplateOutlet="ngContent"></ng-container>
        }
      }
      @case ('overlay') {
        <div class="content-with-overlay__wrap">
          @if (showLoading) {
            <div
              class="overlay"
          [ngStyle]="{
            backgroundColor: overlayColor,
            'height.px': contentHeight,
            'width.px': contentWidth
          }"
              >
              @if (type === 'linear') {
                <div class="linear-wrapper linear-wrapper__overlay">
                  <mat-progress-bar
                    mode="indeterminate"
                    [ngStyle]="{'height.px': linearHeight, 'margin-top.px': -linearHeight}"
                  ></mat-progress-bar>
                </div>
              }
              @if (type === 'circular') {
                <div
                  class="spinner-wrapper"
            [ngStyle]="{
              height: centringCircular ? '100%' : 'initial'
            }"
                  >
                  <mat-spinner [diameter]="circularHeight"></mat-spinner>
                </div>
              }
            </div>
          }
          <div>
            <ng-container *ngTemplateOutlet="ngContent"></ng-container>
          </div>
        </div>
      }
      @case ('disappear') {
        <div class="content__wrap" [class.ignore-clicks]="showLoading" #content>
          @if (showLoading) {
            <div class="loading-indicator_wrap">
              @if (type === 'linear') {
                <div class="linear-wrapper">
                  <mat-progress-bar
                    mode="indeterminate"
                    [ngStyle]="{'height.px': linearHeight, 'margin-top.px': -linearHeight}"
                  ></mat-progress-bar>
                </div>
              }
              @if (type === 'circular') {
                <div
                  class="spinner-wrapper"
            [ngStyle]="{
              position: 'absolute',
              'margin-top.px': centringCircular ? (contentHeight/2 - circularHeight/2) : 0,
              'margin-left.px': centringCircular ? (contentWidth/2 - circularHeight/2) : 0
            }"
                  >
                  <mat-spinner [diameter]="circularHeight"></mat-spinner>
                </div>
              }
            </div>
          }
          <div [@halfDisappear]="showLoading">
            <ng-container *ngTemplateOutlet="ngContent"></ng-container>
          </div>
        </div>
      }
    }

  </ng-container>

  <ng-template #ngContent>
    <div (rtElementResized)="calculateContentSizes()">
      <ng-content></ng-content>
    </div>
  </ng-template>

</div>

